import React from 'react';
import classnames from 'classnames';
import { classes } from './SkeletonLine.st.css';
import { SkeletonLineProps } from './types';

/** SkeletonLine */
export const SkeletonLine = (props: SkeletonLineProps) => (
  <div
    data-hook={props['data-hook']}
    className={classnames(classes.skeletonLine, props.className)}
  ></div>
);
